import requests from 'api/index';

const prefixURL = '/portal/admin';

export default {
  createMenu: payload => requests.post(`${prefixURL}/rest/v1/wizard/menu/insert`, payload),
  createPortlet: payload =>
    requests.post(`${prefixURL}/rest/v1/wizard/portlets/${payload.categoryId}/insert`, payload.data),
  deletePortlet: payload => requests.post(`${prefixURL}/rest/v1/wizard/portlets/${payload.selectedItem}/delete`, {}),
  createCategory: payload => requests.post(`${prefixURL}/rest/v1/wizard/category/0/type/PORTLET/insert`, payload),
  arrangePortlet: payload =>
    requests.post(`${prefixURL}/rest/v1/wizard/placement/compId/${payload.compCd}/home/update`, payload.data),
  setHomeScreen: payload => requests.post(`${prefixURL}/rest/v1/wizard/compconfig/update`, payload),
  deleteMenu: payload =>
    requests.post(
      `${prefixURL}/rest/v1/wizard/menu/delete?menuLabel=${payload.menuLabel}&currentCompId=${payload.currentCompId}`,
      payload,
    ),
  getLoginUser: () => requests.post(`${prefixURL}/rest/v1/wizard/agree-userinfo?noSessionPrc=Y`, {}),
};
